import * as React from 'react';
import MessageSection from '@able/react/dist/MessageSection';
import Spacing from '@able/react/dist/Spacing';
import { IActionRequiredMessageProps } from '@applications/order-tracker/config/order-tracker-new-common/types';
import { productJeopardyCategoryMessageBusinessRules } from '@applications/order-tracker/config/order-tracker-new-common/order-products-utils';

const iconDevelopmentURL = require('../../../../../../../../images/able-sprites.svg');

const JeopardyActionMessage = ({ activity }: IActionRequiredMessageProps) => {
  const { jeopardyActionMessage } =
    productJeopardyCategoryMessageBusinessRules(activity);

  return (
    <Spacing bottom="spacing3x">
      <MessageSection
        titleText={jeopardyActionMessage.title}
        description={jeopardyActionMessage.description}
        variant={jeopardyActionMessage.isWarning ? 'Warning' : 'Information'}
        developmentUrl={iconDevelopmentURL}
      />
    </Spacing>
  );
};

export default JeopardyActionMessage;
